<script lang="ts">
  import { page } from '@inertiajs/svelte';
  import { onMount } from 'svelte';
  import type { Snippet } from 'svelte';

  let {
    ctaText = '1분 만에 인증하고 계속 읽기',
    ctaHref = '/register',
    memberCount = '3,200명의 AX 현직자',
    companies = '삼성전자, 카카오, 네이버',
    previewRatio = 0.25,
    preview,
    full
  }: {
    ctaText?: string;
    ctaHref?: string;
    memberCount?: string;
    companies?: string;
    previewRatio?: number;
    preview?: Snippet;
    full?: Snippet;
  } = $props();

  // 베타 기간: 로그인한 유저는 전체 콘텐츠 접근 가능 (인증 여부 무관)
  // TODO: 베타 종료 후 → Boolean(page.props.auth?.verified) 로 복원
  let isVerified = $derived(Boolean(page.props.auth?.user));

  let contentEl: HTMLDivElement | undefined = $state();
  let clipHeight: string = $state('none');

  onMount(() => {
    if (!contentEl || isVerified) return;
    // 전체 높이의 25% (previewRatio)를 미리보기로 노출, 최소 120px
    const fullH = contentEl.scrollHeight;
    const target = Math.max(Math.round(fullH * previewRatio), 120);
    clipHeight = `${target}px`;
  });
</script>

<div class="relative">
  {#if !isVerified}
    <!-- 본문 미리보기: 전체의 ~25% 노출 -->
    <div
      bind:this={contentEl}
      class="overflow-hidden"
      style:max-height={clipHeight}
    >
      {@render preview?.()}
    </div>

    <!-- 그라디언트 페이드 + CTA -->
    <div class="relative -mt-16">
      <div class="h-16 bg-gradient-to-t from-white to-transparent dark:from-dark-primary"></div>

      <div class="bg-surface-tertiary rounded-2xl p-8 text-center max-w-md mx-auto">
        <p class="text-body1 text-gray-700 dark:text-dark-text-medium mb-6">
          <strong class="text-content">{companies}</strong> 등<br>
          <strong class="text-content">{memberCount}</strong>만 볼 수 있어요.
        </p>

        <a
          href={ctaHref}
          class="inline-flex items-center justify-center w-full
                 px-6 py-4 bg-primary text-white font-semibold rounded-xl
                 hover:bg-primary-light transition-colors"
        >
          {ctaText}
        </a>
      </div>
    </div>
  {:else}
    {@render full?.()}
  {/if}
</div>
